const CACHE_TTL = 1e3 * 60 * 5;
import { computed } from "vue";
import { useNuxtApp, useState } from "#app";
export function useCachedSsrRef(key, value, ttl = CACHE_TTL) {
  const serverCache = useNuxtApp().$storeCache;
  const ref = useState(key, () => serverCache?.get(key) || value);
  useState(key, () => "item");
  if (!serverCache) {
    return ref;
  }
  const wrapper = computed({
    get() {
      return ref.value;
    },
    set(value2) {
      if (process.server) {
        try {
          serverCache.set(key, value2, {
            ttl,
            size: JSON.stringify(value2).length
          });
        } catch (e) {
          console.log(e);
          ref.value = value2;
        }
      }
      ref.value = value2;
    }
  });
  return wrapper;
}
